module.exports = __webpack_public_path__ + "img/Billionaire-4.2e64d779.png";